<template>
  <div class="form-group">
    <label v-once>{{ label }}</label>
    <input v-model="visible" :type="type" :disabled="disabled" class="form-control form-control-sm"/>
  </div>
</template>
<script>
  import isEmpty from 'lodash/fp/isEmpty'
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsFilter,
    props: {
      operator: {type: String, default: 'matches'}
    },
    computed: {
      visible: {
        get() {
          return this.selected ? this.selected.replace(/%/g, '') : null
        },
        set(v) {
          this.selected = isEmpty(v) ? null : `%${v}%`
        }
      }
    }
  }
</script>